export enum ExceptionTypes {
    Sku = "SKU",
    // Store = "Store",
}

export const exceptionTypeOptions = [
    { value: ExceptionTypes.Sku, label: "SKU" },
    // { value: ExceptionTypes.Store, label: "Store" },
];